module.exports = __webpack_public_path__ + "static/media/galerija_2017 (40).5551fdbd.jpg";